const SOURCE_KEYS = new Set([
    'from_place', 'depart_place', 'departure_place', 'from_city', 'depart_city', 'from',
    'to_place', 'arrive_place', 'arrival_place', 'to_city', 'arrive_city', 'to',
    'hotel_name', 'cafe_name', 'description_nature_name', 'description_sightseeing_name',
    'description_activities_name', 'description_other_name', 'sport_name',
    'transport_infrastructure_name', 'other_name', 'activity_name', 'name', 'title',
]);
export const isItemNameSource = (key) => SOURCE_KEYS.has(key);
function calendarDate(value) {
    if (value instanceof Date && Number.isFinite(value.getTime())) {
        return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
    }
    const date = String(value !== null && value !== void 0 ? value : '').slice(0, 10);
    return /^\d{4}-\d{2}-\d{2}$/.test(date) && Number.isFinite(Date.parse(date)) ? date : '';
}
// Match the server's creation keys without requiring an automatic title preview.
export function itemNameRows(type, values, split = false) {
    const itemType = String(type);
    if (!['1', '2', '3', '7'].includes(itemType))
        return [{ key: 'single' }];
    const keys = itemType === '3' ? ['checkin_date', 'checkout_date']
        : itemType === '7' ? ['start_date', 'end_date'] : ['depart_date', 'arrive_date'];
    const [a, b] = keys.map(key => calendarDate(values[key]));
    if (a && b && a === b && itemType !== '3')
        return [{ key: 'single', date: a }];
    if (!a || !b || !split || a === b)
        return [{ key: 'start', date: a }, { key: 'end', date: b }];
    const start = Math.min(Date.parse(a), Date.parse(b)), end = Math.max(Date.parse(a), Date.parse(b));
    const count = Math.round((end - start) / 86400000) + 1;
    if (count > 3660)
        return [{ key: 'start', date: a }, { key: 'end', date: b }];
    return Array.from({ length: count }, (_, index) => {
        const date = new Date(start + index * 86400000).toISOString().slice(0, 10);
        return { key: index === 0 ? 'start' : index === count - 1 ? 'end' : date, date };
    });
}
export function initialItemNameMode(customName = '', overrides = {}) {
    return {
        manual: Boolean(customName || Object.keys(overrides).length),
        names: customName ? { ...overrides, single: customName } : { ...overrides },
        endEdited: Object.prototype.hasOwnProperty.call(overrides, 'end') && overrides.end !== overrides.start,
        changed: false,
    };
}
export function manualItemName(state, key) {
    var _a, _b, _c;
    const first = (_b = (_a = state.names.start) !== null && _a !== void 0 ? _a : state.names.single) !== null && _b !== void 0 ? _b : '';
    if (key === 'end' && !state.endEdited)
        return first;
    return (_c = state.names[key]) !== null && _c !== void 0 ? _c : (key === 'single' || key === 'start' ? first : '');
}
export function setItemNameMode(state, manual, initialTitle = '') {
    return { ...state, manual, changed: true,
        names: manual && initialTitle && !Object.keys(state.names).length ? { single: initialTitle } : state.names };
}
export function changeManualItemName(state, key, value) {
    if (!state.manual)
        return state;
    return { ...state, changed: true, names: { ...state.names, [key]: value,
            ...(key === 'start' ? { single: value } : key === 'single' ? { start: value } : {}) },
        endEdited: state.endEdited || key === 'end' };
}
export function itemNameFieldLabel(type, row, count) {
    if (count === 1)
        return 'Наименование пункта';
    if (row.key === 'start')
        return String(type) === '3' ? 'Наименование заселения' : 'Наименование пункта отправления';
    if (row.key === 'end')
        return String(type) === '3' ? 'Наименование выезда' : 'Наименование пункта прибытия';
    return `Наименование пункта — ${row.date || row.key}`;
}
